"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UIClickable = _interopRequireDefault(require("UIComponents/button/UIClickable"));

var _UICarousel = _interopRequireDefault(require("UIComponents/carousel/UICarousel"));

var _UIButtonWrapper = _interopRequireDefault(require("UIComponents/layout/UIButtonWrapper"));

var _UILightbox = _interopRequireDefault(require("UIComponents/lightbox/UILightbox"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _videoThumbOverlay = _interopRequireDefault(require("bender-url!../../../../img/video-thumb-overlay.png"));

var _useMounted = require("../../../utils/hooks/useMounted");

// https://git.hubteam.com/HubSpot/UIComponents/blob/ed2f3cb96e13c58d9390c3a0be067a18acbbd6bc/UIComponents/static/js/carousel/UICarousel.js#L32
var MAX_STEPS = 5;
var AsyncVideoPlayer = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'video-player' */
    './VideoPlayer');
  }
});

var Carousel = function Carousel(_ref) {
  var onTrackInteraction = _ref.onTrackInteraction,
      screenshots = _ref.screenshots,
      videoUrl = _ref.videoUrl;
  var mounted = (0, _useMounted.useMounted)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      lightboxOpen = _useState2[0],
      setLightboxOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      stepIndex = _useState4[0],
      setStepIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      stepOffset = _useState6[0],
      setStepOffset = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      videoOverlay = _useState8[0],
      setVideoOverlay = _useState8[1];

  (0, _react.useLayoutEffect)(function () {
    if (videoUrl) {
      var overlay = new Image();
      overlay.src = _videoThumbOverlay.default;
      overlay.alt = _I18n.default.text('appMarketplace.detail.overview.video.prompt');
      overlay.style.cssText = 'position: absolute; top: 0; left: 0; z-index: 1; width: 100%;';
      overlay.id = 'carousel-video-overlay';

      overlay.onload = function () {
        var overlayParent = document.querySelector('.with-video footer > div > div:first-child div:first-child div');

        if (overlayParent && mounted) {
          overlayParent.appendChild(overlay);
          setVideoOverlay(overlay);
        }
      };
    }
  }, [mounted, videoUrl]);

  var _useMemo = (0, _react.useMemo)(function () {
    var steps = screenshots.map(function (screenshot) {
      return {
        alt: screenshot.get('altText'),
        image: screenshot.get('imageUrl')
      };
    });

    if (videoUrl) {
      steps = steps.unshift({
        alt: videoUrl,
        image: videoUrl + "\\thumb.jpg"
      });
    }

    return [steps, steps.size];
  }, [screenshots, videoUrl]),
      _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 2),
      immutableSteps = _useMemo2[0],
      totalSteps = _useMemo2[1];

  var onStepIndexChange = (0, _react.useCallback)(function (_ref2) {
    var value = _ref2.target.value;
    var adjustedStepIndex = value + stepOffset;
    var nextStepIndex;
    var nextStepOffset;

    if (adjustedStepIndex === stepOffset && stepOffset > 0) {
      nextStepOffset = stepOffset - MAX_STEPS + 2;
      nextStepIndex = MAX_STEPS - 2;
    } else if (adjustedStepIndex === stepOffset + MAX_STEPS - 1 && adjustedStepIndex < totalSteps - 1) {
      nextStepOffset = stepOffset + MAX_STEPS - 2;
      nextStepIndex = 1;
    } else {
      nextStepOffset = stepOffset;
      nextStepIndex = value;
    }

    setStepIndex(nextStepIndex);
    setStepOffset(nextStepOffset);

    if (videoOverlay) {
      videoOverlay.style.display = adjustedStepIndex <= 3 ? 'block' : 'none';
    }
  }, [setStepIndex, stepOffset, totalSteps, videoOverlay]);
  var renderedLightbox = (0, _react.useMemo)(function () {
    var step = immutableSteps.get(stepIndex + stepOffset);

    if (!(lightboxOpen && step && step.image)) {
      return null;
    }

    return _react.default.createElement(_UILightbox.default, {
      imageAlt: step.alt,
      imageSrc: step.image,
      onClose: function onClose() {
        return setLightboxOpen(false);
      }
    }, _react.default.createElement(_UIButtonWrapper.default, null, step.alt));
  }, [immutableSteps, stepIndex, stepOffset, lightboxOpen, setLightboxOpen]);
  var MainContent = (0, _react.useCallback)(function (_ref3) {
    var children = _ref3.children;
    return children.props.alt && children.props.alt.indexOf('.mp4') !== -1 ? _react.default.createElement(AsyncVideoPlayer, {
      onTrackInteraction: onTrackInteraction,
      videoUrl: children.props.alt
    }) : _react.default.createElement(_UIClickable.default, {
      onClick: function onClick() {
        setLightboxOpen(true);
        onTrackInteraction('click carousel screenshot', 'overview');
      }
    }, children);
  }, [setLightboxOpen, onTrackInteraction]);
  var singleClickableField = (0, _react.useMemo)(function () {
    var item = immutableSteps.first();

    if (!item) {
      return null;
    }

    return item.alt && item.alt.indexOf('.mp4') !== -1 ? _react.default.createElement(AsyncVideoPlayer, {
      videoUrl: item.alt
    }) : _react.default.createElement(_UIClickable.default, {
      onClick: function onClick() {
        setLightboxOpen(true);
        onTrackInteraction('click carousel screenshot', 'overview');
      }
    }, _react.default.createElement(_UIImage.default, {
      alt: item.alt || '',
      src: item.image,
      style: {
        margin: 'auto'
      }
    }));
  }, [immutableSteps, setLightboxOpen, onTrackInteraction]);

  if (immutableSteps.isEmpty()) {
    return null;
  }

  return _react.default.createElement(_react.Fragment, null, immutableSteps.size > 1 ? _react.default.createElement(_UICarousel.default, {
    className: videoUrl && 'with-video',
    MainContent: MainContent,
    onStepIndexChange: onStepIndexChange,
    stepIndex: stepIndex,
    steps: immutableSteps.slice(stepOffset, stepOffset + MAX_STEPS).toArray(),
    use: "max"
  }) : _react.default.createElement("div", {
    className: "m-top-6"
  }, singleClickableField), renderedLightbox);
};

Carousel.propTypes = {
  onTrackInteraction: _propTypes.default.func.isRequired,
  screenshots: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  videoUrl: _propTypes.default.string
};
var _default = Carousel;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/Carousel.js
// module id = 799
// module chunks = 209 210 211 212